import { Snackbar as SnackBarDS, MaterialUICore } from '@iclinic/design-system';

const { styled } = MaterialUICore;

export const Snackbar = styled(SnackBarDS)({
  zIndex: 10000,
});
